module.exports = __webpack_public_path__ + "media/images/emblems/Kirchlindach-coat_of_arms-cf463c7d6db7f925b1effca78d5740ff.svg";